import { useEffect, useState } from "react";
import "../styles/Coberturas.css";
import CoberturasCards from "./CoberturasCards";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import {
  ButtonNextMobile,
  ButtonPreviousMobile,
  SeguroAlerta,
} from "../../../../assets/icons/Icons";

const Coberturas = ({ coberturas, coberturasDesc }) => {
  const [cobertura, setCobertura] = useState();

  const responsive = {
    320: {
      items: 1,
    },
    576: {
      items: 1,
    },
    768: {
      items: 1,
      itemsFit: "contain",
    },
    1024: {
      items: 2,
      itemsFit: "contain",
    },
    1200: {
      items: 3,
      itemsFit: "contain",
    },
    1400: {
      items: 3,
      itemsFit: "contain",
    },
    1600: {
      items: 3,
      itemsFit: "contain",
    },
    1800: {
      items: 3,
      itemsFit: "contain",
    },
  };

  const años = [
    {
      año: 1,
      texto: "RTI + Deducible Valor Comercial",
    },
    {
      año: 2,
      texto: "Deducible Valor Comercial + Beneficios",
    },
    {
      año: 3,
      texto: "Deducible Valor Comercial + Beneficios",
    },
    {
      año: 4,
      texto: "Deducible Valor Comercial + Beneficios",
    },
  ];

  useEffect(() => {
    if (coberturas?.length < 1 || coberturas === undefined) return;
    let arregloCobertura = [];
    coberturas?.forEach((element) => {
      let arregloDescripcionesCobertura = [];
      coberturasDesc?.forEach((desc) => {
        if (desc.idCobertura === element.id) {
          arregloDescripcionesCobertura.push(desc);
        }
      });
      arregloCobertura.push(
        <CoberturasCards
          cobertura={element}
          coberturasDesc={arregloDescripcionesCobertura}
        />
      );
    });
    setCobertura(arregloCobertura);
  }, [coberturas, coberturasDesc]);

  return (
    <>
      <div
        id="coberturas"
      >
        <div
          className="homeout__coberturas container mt-lg-5 pt-lg-5"
          style={{ paddingBottom: "3rem" }}
        >
          <h2
            style={{
              color: "var(--principal)",
              marginTop: "2rem",
              padding: "0 5%",
            }}
          >
            Tus coberturas
          </h2>

          {/* :::::TEXTO ESCRITORIO:::::: */}
          <p
            className="d-none d-md-inline"
            style={{
              paddingBottom: "2.5rem",
              fontSize: "2rem",
              marginTop: "3rem",
            }}
          >
            Las coberturas se activan{" "}
            <b>dependiendo del año en el que ocurra el evento</b>, brindándote
            además <b>beneficios adicionales</b> en caso de que desees adquirir
            otro financiamiento a través del mismo distribuidor.
          </p>

          {/* :::::TEXTO MOVIL:::::: */}
          <p
            className="d-md-none"
            style={{
              paddingBottom: "2.5rem",
              fontSize: "2rem",
              marginTop: "3rem",
            }}
          >
            Las coberturas se activan{" "}
            <b>dependiendo del año en el que ocurra el evento</b>, brindándote
            además <b>beneficios adicionales</b> en caso de que desees adquirir
            otro financiamiento a través del mismo distribuidor.
          </p>

          <div className="stepper container d-none d-md-flex">
            <div className="stepper__line"></div>
            {años.map((label, index) => (
              <div className="step">
                <p className="stepper__title">Año</p>
                <div className="stepper__circle">{label.año}</div>
                <div className="stepper__label">{label.texto}</div>
              </div>
            ))}
          </div>

          <div className="stepper__mobile d-md-none">
            {años.map((label, index) => (
              <div className="stepper__mobile__años">
                <p
                  style={{
                    color: "var(--principal)",
                    fontFamily: "Inter",
                    fontSize: "13px",
                    fontWeight: 700,
                  }}
                >
                  Año {label.año}:
                </p>
                <p
                  style={{
                    fontFamily: "Inter",
                    fontSize: "13px",
                    marginLeft: "1rem",
                  }}
                >
                  {label.texto}
                </p>
              </div>
            ))}
          </div>

          <div className="div__carousel__coberturas">
            {cobertura?.length > 0 && (
              <AliceCarousel
                items={cobertura}
                responsive={responsive}
                centerMode={true}
                disableDotsControls
                renderPrevButton={({ isDisabled }) => {
                  return (
                    <>
                      {!isDisabled && (
                        <div className="btn__prev__coberturas">
                          <ButtonPreviousMobile />
                        </div>
                      )}
                    </>
                  );
                }}
                renderNextButton={({ isDisabled }) => {
                  return (
                    <>
                      {!isDisabled && (
                        <div className="btn__next__coberturas">
                          <ButtonNextMobile />
                        </div>
                      )}
                    </>
                  );
                }}
              />
            )}
          </div>
          <div className="no__cubre">
            <div className="no__cubre__icon">
              <SeguroAlerta />
            </div>
            <div className="no__cubre__texto">
              <h2>¿Qué no cubre mi seguro?</h2>
              <p className="d-none d-md-inline">
                Eventos no dictaminados como pérdida total o robo total previamente por la
                aseguradora primaria.{" "}
              </p>
              <p className="d-md-none">
                Eventos no dictaminados como pérdida total o robo total previamente por la aseguradora primaria. 
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Coberturas;
